import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DashboardCardComponent } from '../dashboard-card/dashboard-card.component';

interface RevenueSummaryRow {
   label: string;
   day: number;
   lastYear: number;
   budget: number;
}

@Component({
   selector: 'app-dashboard-revenue-summary',
   standalone: true,
   imports: [CommonModule, DashboardCardComponent],
   templateUrl: './revenue-summary.component.html',
   styleUrls: ['./revenue-summary.component.scss']
})
export class RevenueSummaryComponent {
   // Illustrative values only. Do not populate this table from live property data
   // until the Revenue Summary add-on is available for the property.
   readonly rows: ReadonlyArray<RevenueSummaryRow> = [
      { label: 'Total', day: 24320, lastYear: 20410, budget: 23800 },
      { label: 'Rooms', day: 18420, lastYear: 17190, budget: 17900 },
      { label: 'F&B', day: 4670, lastYear: 1980, budget: 4400 },
      { label: 'Other', day: 1230, lastYear: 1240, budget: 1500 }
   ];
}
